import * as Rest from 'src/constants/rest'
import { Company } from 'src/interfaces'
import http from 'src/utils/Http'

export interface Response {
  results: Company[]
}

export function getCompanies(): Promise<Response> {
  return http
    .get({
      url: Rest.COMPANIES,
      token: true
    })
    .then(res => ({
      results: res
    }))
}
